import { startOfWeek } from 'date-fns'

/**
 * Get the start of the week (Monday) for a given date
 * Uses date-fns with weekStartsOn: 1 for Monday
 */
export const getWeekStart = (date: Date): Date => {
	return startOfWeek(date, { weekStartsOn: 1 })
}

export function formatTime(date: Date | string | undefined): string {
	if (!date) return '—'
	return new Date(date).toLocaleTimeString('ru-RU', {
		hour: '2-digit',
		minute: '2-digit',
	})
}

export function formatDateTime(date: Date | string | undefined): string {
	if (!date) return '—'
	return new Date(date).toLocaleString('ru-RU', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	})
}
